import React from "react";
import { Tooltip as BootstrapTooltip } from "react-bootstrap";
import styled, { css } from "styled-components";
const arrowSize = 10;
const StyledTooltip = styled(BootstrapTooltip)(
  ({ theme }) => css`
    &.in {
      opacity: 1;
      filter: drop-shadow(0 0 3px ${theme.colors.variant.lighter.default});
    }

    &.top {
      .tooltip-arrow {
        border-top-color: ${theme.colors.global.contentBackground};
        border-width: ${arrowSize}px ${arrowSize}px 0;
        margin-left: -${arrowSize}px;
        bottom: -${arrowSize / 2}px;
      }
    }

    &.right {
      .tooltip-arrow {
        border-right-color: ${theme.colors.global.contentBackground};
        border-width: ${arrowSize}px ${arrowSize}px ${arrowSize}px 0;
        margin-top: -${arrowSize}px;
        left: -${arrowSize / 2}px;
      }
    }

    &.bottom {
      .tooltip-arrow {
        border-bottom-color: ${theme.colors.global.contentBackground};
        border-width: 0 ${arrowSize}px ${arrowSize}px;
        margin-left: -${arrowSize}px;
        top: -${arrowSize / 2}px;
      }
    }

    &.left {
      .tooltip-arrow {
        border-left-color: ${theme.colors.global.contentBackground};
        border-width: ${arrowSize}px 0 ${arrowSize}px ${arrowSize}px;
        margin-top: -${arrowSize}px;
        right: -${arrowSize / 2}px;
      }
    }

    .tooltip-inner {
      color: ${theme.colors.text.primary};
      background-color: ${theme.colors.global.contentBackground};
      max-width: 300px;
      opacity: 1;

      .datapoint-info {
        text-align: left;

        .date {
          color: ${theme.colors.variant.darkest.default};
        }
      }
    }
  `
);
const Tooltip = ({
  children,
  className = "",
  id,
  placement = "right",
  positionTop = void 0,
  positionLeft = void 0,
  arrowOffsetTop = void 0,
  arrowOffsetLeft = void 0,
  show = true
}) => /* @__PURE__ */ React.createElement(
  StyledTooltip,
  {
    className: `${className} ${show ? "in" : ""}`,
    id,
    placement,
    positionTop,
    positionLeft,
    arrowOffsetTop,
    arrowOffsetLeft
  },
  children
);
export default Tooltip;
